Ext.define('SA.HistogramYScale', {
    constructor({maxCount, frameSize}) {
        var domain = [0, maxCount],
            range = [0, frameSize.height];

        this.height = frameSize.height;
        this.scale = d3.scaleLinear().domain(domain).range(range).nice();

        this.ticks = this.createTicks();
    },

    createTicks() {
        var counts = this.scale.ticks().filter(count => Number.isInteger(count)),
            formatter = SA.TickFormatter.get({values: counts});

        return counts.map(count => ({
            y: this.getYForCount(count),
            label: formatter.format(count)
        }));
    },

    getBarHeightForCount(count) {
        return this.scale(count);
    },

    getYForCount(count) {
        return this.height - this.getBarHeightForCount(count);
    },

    mapTicks(fn) {
        return this.ticks.map(fn);
    }
});